/* eslint-disable max-lines */
import store from '@/store/index';
import { allNumber } from '@/modules/mdm/utils/regList.js';
const { user } = store.getters;

export const config = {
    name: 'customerPersonResponsible',
    searchFields: [
        {
            name: '单据号',
            value: 'id',
            isFixed: false,
            type: 'input',
            span: 3
        },
        {
            name: '客户名称',
            value: 'customerName',
            type: 'advanceMulti',
            advanceConfig: [
                { prop: 'customerName', value: '客户名称', 'displayName': 'customerName' },
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerGroupName', value: '客户系' }
            ],
            tableConfig: [
                { prop: 'customerName', value: '客户名称', 'displayName': 'customerName' },
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerGroupName', value: '客户系' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/customer/info/page',
            cbParams: [
                'customerCode#customerCode',
                'customerName#customerName'
            ],
            beforeRequest: (params) => {
                return params;
            },
            isFixed: true,
            span: 5
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advanceMulti',
            // maxNum: 10, // 多选条数限制
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode', 'companyNameCn#companyName']
        },
        {
            name: '经营中心',
            value: 'businessCenterName',
            type: 'advanceMulti',
            // maxNum: 10, // 多选条数限制
            isFixed: true,
            span: 5,
            advanceConfig: [
                { prop: 'businessCenterName', value: '责任经营中心名称' },
                { prop: 'businessCenterCode', value: '责任经营中心编码' }
            ],
            tableConfig: [
                { prop: 'businessCenterName', value: '责任经营中心名称', 'displayName': 'businessCenterName' },
                { prop: 'businessCenterCode', value: '责任经营中心编码' }
            ],
            prefix: '/api-lcs',
            advanceUrl: '/bid/queryCompanyByCodeAndName',
            cbParams: ['businessCenterCode', 'businessCenterName']
            // advanceCascade: 'companyCode#companyCode' // 关联入参只针对单选有效
        },
        {
            name: '行业',
            value: 'industryCategoriesCodeList',
            type: 'select',
            multiple: true,
            optionNum: 'SYS_SUPPLIER_INDUSTRY',
            isFixed: false,
            span: 3
        },
        {
            name: '细分行业',
            value: 'industryTypeName',
            type: 'advance',
            // maxNum: 10, // 多选条数限制
            isFixed: false,
            span: 3,
            disabled: true,
            advanceConfig: [
                { 'prop': 'industryTypeName', 'value': '细分行业' }
            ],
            tableConfig: [
                { 'prop': 'industryCategoriesName', 'value': '行业大类' },
                { 'prop': 'industryCategoriesCode', 'value': '行业大类编码' },
                { 'prop': 'industryTypeName', 'value': '细分行业' },
                { 'prop': 'industryTypeCode', 'value': '细分行业编码' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: `/industry/info/page`,
            cbParams: ['industryTypeCode', 'industryTypeName'],
            advanceCascade: 'industryCategoriesCodeList',
            beforeRequest: (params) => {
                if (params.industryCategoriesCodeList && Array.isArray(params.industryCategoriesCodeList)) {
                    params.industryCategoriesCode = params.industryCategoriesCodeList.join(',');
                    delete params.industryCategoriesCodeList;
                }
                return params;
            }
        },
        {
            name: '分摊类型',
            value: 'respDivide',
            type: 'select',
            optionNum: 'NEOCRM_RESP_DIVIDE',
            isFixed: true,
            span: 4
        },
        {
            name: '客户经理',
            value: 'customerOwnerName',
            span: 3,
            type: 'advance',
            isFixed: false,
            advanceConfig: [
                { prop: 'esusUserNameCn', value: '客户名称' },
                { prop: 'esusLoginName', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'esusLoginName', value: '客户编码' },
                { prop: 'esusUserNameCn', value: '客户名称', 'displayName': 'esusUserNameCn' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/crmUser/page',
            cbParams: ['esusLoginName#customerOwnerCode', 'esusUserNameCn#customerOwnerName'],
            advanceCode: 'advanceCode'
        },
        // {
        //     name: '属地行业负责人',
        //     value: 'regionManagerName',
        //     type: 'input',
        //     isFixed: false,
        //     span: 3
        // },
        // {
        //     name: '属地行业负责人',
        //     value: 'regionManagerName',
        //     type: 'advance',
        //     advanceConfig: [
        //         { prop: 'userName', value: '用户名称' },
        //         { prop: 'userCode', value: '用户编码' },
        //         { prop: 'departmentName', value: '分公司名称' },
        //         { prop: 'industryName', value: '行业名称' }
        //     ],
        //     tableConfig: [
        //         { prop: 'userCode', value: '用户编码' },
        //         { prop: 'userName', value: '用户名称' },
        //         // { prop: 'departmentName', value: '分公司名称' },
        //         { prop: 'industryName', value: '行业名称' }
        //     ],
        //     method: 'post',
        //     prefix: '/api-lcrm',
        //     advanceUrl: '/companyIndustryManager/page',
        //     cbParams: [
        //         'userCode#userCode',
        //         'userName#regionManagerName'
        //     ],
        //     beforeRequest: (params) => {
        //         return params;
        //     },
        //     isFixed: true,
        //     span: 3
        // },
        {
            name: '客户系',
            value: 'customerGroupName',
            type: 'advanceMulti',
            isFixed: false,
            span: 3,
            advanceConfig: [
                { prop: 'customerGroupName', value: '客户系名称' },
                { prop: 'customerGroupCode', value: '客户系编码' }
            ],
            tableConfig: [
                { prop: 'customerGroupCode', value: '客户系编码' },
                { prop: 'customerGroupName', value: '客户系名称', 'displayName': 'customerGroupName' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/customer/group/info/page',
            cbParams: ['customerGroupCode', 'customerGroupName'],
            advanceCode: 'advanceCode'
        },
        {
            name: '客户等级',
            value: 'calCustomerLevelCode',
            type: 'select',
            optionNum: 'NEOCRM_CUSTOMER_LEVEL',
            isFixed: false,
            span: 3
        },
        {
            name: '片区',
            value: 'regionCodeList',
            type: 'select',
            multiple: true,
            optionNum: 'APP_COMPANY_AREA',
            isFixed: false,
            span: 3
        },
        {
            name: '责任人',
            value: 'ownerCodeList',
            type: 'input',
            isFixed: false,
            placeholder: '责任人Mip(包含离职人员)',
            span: 3
        },

        {
            name: '维护状态',
            value: 'maintainStatusList',
            type: 'select',
            optionNum: 'MANAGER_ARCHIVE_MAINTAIN_STATUS',
            isFixed: true,
            multiple: true,
            span: 5
        },
        {
            name: '变更单流程状态',
            value: 'mipStatusList',
            type: 'select',
            options: [
                { value: '0', label: '空' },
                { value: '1', label: '草稿' },
                { value: '2', label: '待审批' },
                { value: '3', label: '审批中' },
                { value: '4', label: '审批通过' },
                { value: '5', label: '审批驳回' },
                { value: '6', label: '撤回' },
                { value: '7', label: '作废' }
            ],
            isFixed: true,
            multiple: true,
            span: 5
        },
        {
            name: '失效日期',
            value: 'effectEndTimeFixed',
            isFixed: true,
            type: 'time',
            time: 'daterange',
            format: 'yyyy-MM-dd',
            startPlaceholder: '失效日期从',
            endPlaceholder: '失效日期到',
            // eslint-disable-next-line no-magic-numbers
            // defaultValue: [new Date('2099', '1', '1'), new Date('2099', '1', '1')],
            span: 8
        },
        {
            name: '生效日期',
            value: 'effectTime',
            isFixed: false,
            type: 'time',
            time: 'daterange',
            startPlaceholder: '生效日期从',
            endPlaceholder: '生效日期到',
            span: 3
        },
        {
            name: '变更前',
            value: 'historicalState',
            type: 'input',
            isFixed: false,
            placeholder: '变更前',
            span: 3
        },
        {
            name: '单据所有人',
            value: 'billOwnerName',
            type: 'advance',
            // maxNum: 10, // 多选条数限制
            isFixed: false,
            span: 3,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                // { 'prop': 'esusPositionName', 'value': '职位' }, // 新接口没有这个字段
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/crmUser/page`,
            cbParams: ['esusUserNameCn#billOwnerName', 'esusLoginName#billOwnerCode'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            }
        },
        {
            name: '单据所在部门',
            value: 'billDepartmentName',
            type: 'advance',
            // maxNum: 10, // 多选条数限制
            isFixed: false,
            span: 3,
            advanceConfig: [
                { 'prop': 'departmentName', 'value': '所在部门名称' },
                { 'prop': 'departmentCode', 'value': '所在部门编码' }
            ],
            tableConfig: [
                { 'prop': 'departmentCode', 'value': '所在部门编码' },
                { 'prop': 'departmentName', 'value': '所在部门名称', 'displayName': 'departmentName' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: `/customer/manager/archive/billDepartment/collect`,
            cbParams: ['departmentCode#billDepartmentCode', 'departmentName#billDepartmentName']
        },

        {
            name: '单据来源类型',
            value: 'billSource',
            type: 'select',
            optionNum: 'MANAGER_BILL_SOURCE_REMARK',
            isFixed: false,
            span: 3
        },
        {
            name: '单据来源说明',
            value: 'billSourceRemark',
            type: 'input',
            isFixed: false,
            span: 3
        },
        {
            name: '最新修改人',
            value: 'updateUserName',
            type: 'advance',
            // maxNum: 10, // 多选条数限制
            isFixed: false,
            span: 3,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名', 'displayName': 'esusUserNameCn' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#updateUserName', 'esusLoginName#updateUserCode'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            }
        },
        {
            name: '创建时间',
            value: 'createTime',
            isFixed: false,
            type: 'time',
            time: 'daterange',
            startPlaceholder: '创建时间从',
            endPlaceholder: '创建时间到',
            // eslint-disable-next-line no-magic-numbers
            // defaultValue: new Date('2025', '1', '1'),
            span: 3
        },
        {
            name: '最新修改时间',
            value: 'updateTimes',
            isFixed: false,
            type: 'time',
            time: 'daterange',
            startPlaceholder: '最新修改时间从',
            endPlaceholder: '最新修改时间到',
            span: 3
        },
        {
            name: '异常数据',
            value: 'ruleStatus',
            type: 'select',
            optionNum: 'MONITOR_STATUS',
            isFixed: true,
            span: 4
        }
    ],
    selection: true,
    index: false,
    columns: [
        {
            label: '单据号',
            prop: 'id',
            fixed: 'left'
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            width: 120,
            sort: true,
            fixed: 'left',
            mustFill: true
        },
        {
            label: '客户名称',
            prop: 'customerName',
            fixed: 'left',
            type: 'advance',
            name: '客户名称',
            mustFill: true,
            advanceConfig: [
                { prop: 'customerName', value: '客户名称' },
                { prop: 'customerCode', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'accountName', value: '客户名称' },
                { prop: 'customItem232__c', value: '客户编码' },
                { prop: 'customItem169__c', value: '客户简称' },
                { prop: 'accountId', value: '账号ID' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/contract/customer/account/relation',
            cbParams: [
                'customItem232__c#customerCode',
                'accountName#customerName'
            ],
            beforeRequest: (params) => {
                params.userCode = user.userCode;
                return params;
            },
            width: 160
        },

        // {
        //     label: '客户名称',
        //     prop: 'customerName',
        //     width: 140,
        //     sort: true,
        //     mustFill: true
        // },

        {
            label: '分公司',
            prop: 'companyName',
            type: 'advance',
            name: '添加分公司',
            fixed: 'left',
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode', 'companyNameCn#companyName'],
            mustFill: false,
            width: 120
        },
        {
            label: '经营中心',
            prop: 'businessCenterName',
            type: 'advance',
            name: '添加经营中心',
            fixed: 'left',
            advanceConfig: [
                { prop: 'businessCenterName', value: '责任经营中心名称' },
                { prop: 'businessCenterCode', value: '责任经营中心编码' }
            ],
            tableConfig: [
                { prop: 'businessCenterName', value: '责任经营中心名称' },
                { prop: 'businessCenterCode', value: '责任经营中心编码' }
            ],
            prefix: '/api-lcs',
            advanceUrl: '/bid/queryCompanyByCodeAndName',
            cbParams: ['businessCenterCode', 'businessCenterName'],
            advanceCascade: 'companyCode#companyCode',
            mustFill: true,
            width: 120
        },
        {
            label: '行业',
            prop: 'industryCategoriesName',
            fixed: 'left',
            width: 100
        },
        {
            label: '细分行业',
            prop: 'industryType',
            slot: true,
            type: 'slot',
            editSlot: true,
            optionsKey: 'SYS_INDUSTRY_TYPE',
            width: 100
        },
        {
            label: '分摊类型',
            prop: 'respDivide',
            type: 'select',
            optionsKey: 'NEOCRM_RESP_DIVIDE', // TODO
            mustFill: true,
            placeholder: '分摊类型',
            width: 120
        },
        {
            label: '客户经理',
            prop: 'customerOwnerName',
            width: 140
        },
        {
            label: '属地行业负责人',
            prop: 'regionManagerName',
            width: 140
        },
        {
            label: '客户系',
            prop: 'customerGroupCode',
            slot: true,
            type: 'slot',
            editSlot: true,
            optionsKey: 'SYS_CUST_RELATION_TYPE',
            width: 140
        },
        {
            label: '客户等级',
            prop: 'calCustomerLevelCode',
            slot: true,
            type: 'slot',
            editSlot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
            width: 120
        },
        {
            label: '片区',
            prop: 'region',
            width: 100
        },
        // {
        //     label: '服务平台',
        //     prop: 'siteName',
        //     type: 'advance',
        //     name: '添加服务平台',
        //     advanceConfig: [
        //         { 'prop': 'siteNameCn', 'value': '服务平台名称' },
        //         { 'prop': 'siteCode', 'value': '服务平台编码' }
        //     ],
        //     tableConfig: [
        //         { 'prop': 'siteCode', 'value': '服务平台编码' },
        //         { 'prop': 'siteNameCn', 'value': '服务平台名称' }
        //     ],
        //     prefix: '/api-mdm',
        //     advanceUrl: `/esCompany/popSite`,
        //     cbParams: ['siteCode', 'siteNameCn#siteName'],
        //     advanceCascade: 'companyCode#companyCode',
        //     mustFill: false,
        //     width: 180
        // },
        {
            label: '主责任人1',
            prop: 'ownerName1',
            value: 'ownerName1',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName1', 'esusLoginName#ownerCode1'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 150
        },
        {
            label: '主责任人MIP1',
            prop: 'ownerCode1',
            width: 140
        },
        {
            label: '主责任人比例1',
            prop: 'ownerRatio1',
            type: 'input',
            verify: allNumber,
            width: 140
        },
        {
            label: '责任人2',
            prop: 'ownerName2',
            value: 'ownerName2',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName2', 'esusLoginName#ownerCode2'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 150
        },
        {
            label: '责任人MIP2',
            prop: 'ownerCode2',
            width: 140
        },
        {
            label: '责任人比例2',
            prop: 'ownerRatio2',
            type: 'input',
            verify: allNumber,
            width: 140
        },
        {
            label: '责任人3',
            prop: 'ownerName3',
            value: 'ownerName3',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName3', 'esusLoginName#ownerCode3'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 150
        },
        {
            label: '责任人MIP3',
            prop: 'ownerCode3',
            width: 140
        },
        {
            label: '责任人比例3',
            prop: 'ownerRatio3',
            type: 'input',
            verify: allNumber,
            width: 140
        },
        {
            label: '责任人4',
            prop: 'ownerName4',
            value: 'ownerName4',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName4', 'esusLoginName#ownerCode4'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 150
        },
        {
            label: '责任人MIP4',
            prop: 'ownerCode4',
            width: 140
        },
        {
            label: '责任人比例4',
            prop: 'ownerRatio4',
            verify: allNumber,
            type: 'input',
            width: 140
        },
        {
            label: '责任人5',
            prop: 'ownerName5',
            value: 'ownerName5',
            name: '添加责任人',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#ownerName5', 'esusLoginName#ownerCode5'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 150
        },
        {
            label: '责任人MIP5',
            prop: 'ownerCode5',
            width: 140
        },
        {
            label: '责任人比例5',
            prop: 'ownerRatio5',
            type: 'input',
            verify: allNumber,
            width: 140
        },

        {
            label: '行业公共池比例',
            prop: 'industryCommonPoolRatio',
            type: 'input',
            placeholder: '行业公共池比例',
            width: 140
        },
        {
            label: '分公司公共池比例',
            prop: 'companyCommonPoolRatio',
            placeholder: '分公司公共池比例',
            type: 'input',
            width: 140
        },
        {
            label: '单据所有人',
            prop: 'billOwnerName',
            value: 'billOwnerName',
            name: '添加单据所有人',
            type: 'advance',
            mustFill: true,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                // { 'prop': 'esusPositionName', 'value': '职位' }, // 新接口没有这个字段
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/crmUser/page`,
            cbParams: ['esusUserNameCn#billOwnerName', 'esusLoginName#billOwnerCode', 'departmentCode#billDepartmentCode', 'escoCompanyNameCn#billDepartmentName'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 150
        },
        {
            label: '单据所在部门',
            prop: 'billDepartmentName',
            value: 'billDepartmentName',
            name: '添加单据所在部门',
            type: 'advance',
            mustFill: true,
            advanceConfig: [
                { 'prop': 'departmentName', 'value': '所在部门名称' },
                { 'prop': 'departmentCode', 'value': '所在部门编码' }
            ],
            tableConfig: [
                { 'prop': 'departmentCode', 'value': '所在部门编码' },
                { 'prop': 'departmentName', 'value': '所在部门名称', 'displayName': 'departmentName' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: `/customer/manager/archive/billDepartment/collect`,
            cbParams: ['departmentCode#billDepartmentCode', 'departmentName#billDepartmentName'],
            // beforeRequest: (params) => {
            //     const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
            //     const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
            //     if (reg.test(inputKey)) {
            //         params.esusUserNameCn = inputKey;
            //         params.esusLoginName = null;
            //     } else {
            //         params.esusLoginName = inputKey;
            //         params.esusUserNameCn = null;
            //     }
            //     return params;
            // },
            width: 150
        },
        // {
        //     label: '开发单位',
        //     prop: 'developmentUnitName',
        //     value: 'developmentUnitName',
        //     type: 'advance',
        //     visible: true,
        //     rule: [
        //         { required: true, message: '开发单位不能为空', trigger: ['change', 'blur'] }
        //     ],
        //     advanceConfig: [
        //         { 'prop': 'companyNameCn', 'value': '开发单位名称' },
        //         { 'prop': 'companyCode', 'value': '开发单位编码' }
        //     ],
        //     tableConfig: [
        //         { 'prop': 'companyCode', 'value': '开发单位编码' },
        //         { 'prop': 'companyNameCn', 'value': '开发单位名称' }
        //     ],
        //     prefix: '/api-mdm',
        //     advanceUrl: `/esCompany/popCompany`,
        //     cbParams: ['companyCode#developmentUnit', 'companyNameCn#developmentUnitName']
        // },
        {
            label: '单据来源类型',
            prop: 'billSource',
            type: 'select',
            optionsKey: 'MANAGER_BILL_SOURCE_REMARK', // TODO
            // options: {
            //     '1': '商机创建',
            //     '2': '合同创建',
            //     '3': '收入创建'
            // },
            mustFill: true,
            placeholder: '单据来源类型',
            width: 140
        },
        {
            label: '单据来源说明',
            prop: 'billSourceRemark',
            type: 'input',
            mustFill: true,
            placeholder: '单据来源说明',
            width: 140
        },
        {
            label: '生效日期',
            prop: 'effectStartTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            // pickerOptions: effectDisabledDate(),
            width: 160
        },
        {
            label: '失效日期',
            prop: 'effectEndTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            // pickerOptions: { disabledDate },
            mustFill: true,
            width: 160
        },
        {
            label: '变更前',
            prop: 'historicalState',
            // type: 'select',
            // optionsKey: 'historicalState', // TODO
            // placeholder: '变更前',
            width: 140
        },
        {
            label: '维护状态',
            prop: 'maintainStatus',
            slot: true,
            type: 'slot',
            editSlot: true,
            mustFill: true,
            placeholder: '维护状态',
            width: 140
        },
        {
            label: '最新变更单',
            prop: 'mipUrl',
            slot: true,
            type: 'slot',
            editSlot: true,
            placeholder: '最新变更单',
            width: 140
        },
        {
            label: '变更单流程状态',
            prop: 'mipStatus',
            slot: true,
            optionsKey: 'SYS_SU_MIP_AUDIT_STATUS',
            type: 'slot',
            editSlot: true,
            placeholder: '变更单流程状态',
            width: 140
        },
        {
            label: '创建人',
            prop: 'createUserName',
            width: 154
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 154
        },
        {
            label: '最后修改人',
            prop: 'updateUserName',
            width: 154
        },
        {
            label: '最后修改时间',
            prop: 'updateTime',
            width: 154
        },
        {
            label: '异常数据',
            prop: 'ruleStatus',
            slot: true,
            optionsKey: 'MONITOR_STATUS',
            type: 'slot',
            editSlot: true,
            width: 120
        },
        {
            label: '异常原因',
            prop: 'errorMsg',
            width: 160
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 80, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: []
    },
    rowClickFunc: (row) => {
        // 4 变更中 2维护中
        return ![2, 4].includes(+row.maintainStatus);
    },
    lotInputParams: {
        label: '单据所有人',
        prop: 'billOwnerName',
        value: 'billOwnerName',
        name: '添加单据所有人',
        type: 'advance',
        mustFill: true,
        advanceConfig: [
            { 'prop': 'esusUserNameCn', 'value': '姓名' },
            { 'prop': 'esusLoginName', 'value': '美信号' }
        ],
        tableConfig: [
            { 'prop': 'esusLoginName', 'value': '美信号' },
            { 'prop': 'esusUserNameCn', 'value': '姓名' },
            // { 'prop': 'esusPositionName', 'value': '职位' }, // 新接口没有这个字段
            { 'prop': 'escoCompanyNameCn', 'value': '部门' }
        ],
        prefix: '/api-lcrm',
        advanceUrl: `/crmUser/page`,
        cbParams: ['esusUserNameCn#billOwnerName', 'esusLoginName#billOwnerCode', 'departmentCode#billDepartmentCode', 'escoCompanyNameCn#billDepartmentName'],
        beforeRequest: (params) => {
            const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
            const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
            if (reg.test(inputKey)) {
                params.esusUserNameCn = inputKey;
                params.esusLoginName = null;
            } else {
                params.esusLoginName = inputKey;
                params.esusUserNameCn = null;
            }
            return params;
        },
        width: 150
    }
};
